<template>
  <div id="app">
    <md-app md-mode="fixed">
      <md-app-toolbar>
        <md-button class="md-icon-button mobile__menu-icon"
                   v-if="isLoggedIn"
                   @click="menuVisible = !menuVisible">
          <md-icon>menu</md-icon>
        </md-button>
        <navbar/>
      </md-app-toolbar>
      <md-app-drawer md-permanent="clipped"
                     :md-active.sync="menuVisible"
                     v-if="isLoggedIn"
                     class="scrollbar">
        <sidebar v-on:hide-sidebar="hideSidebar"
                 @show-popup="openPopup"
                 @close-popup="closePopup"
        />
      </md-app-drawer>
      <md-app-content>
        <router-view/>
        <snackbar/>
        <file-viewer/>
        <loader-bar/>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
  import Navbar from '@vue/navigation/Navbar.vue'
  import Sidebar from '@vue/navigation/Sidebar.vue'
  import Snackbar from '@com/messages/Snackbar'
  import FileViewer from '@com/modals/FileViewer'
  import LoaderBar from '@com/messages/LoaderBar'
  import Logotype from '@vue/app/common/Logotype'

  import { vueRoutes } from '@router/const'

  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  import {dispatchAppEvent, attachEventHandler} from '@js/events/helpers'
  import { commonEvents } from '@js/events/common_events'
  export default {
    name: 'app',

    components: {
      Navbar,
      Sidebar,
      Snackbar,
      FileViewer,
      LoaderBar,
      Logotype
    },

    data: () => ({
      menuVisible: false,
      showPopup: false
    }),

    computed: {
      ...mapGetters([
        vuexTypes.userAccountId,
        vuexTypes.isLoggedIn,
        vuexTypes.userEmail
      ])
    },

    mounted () {
      if (this.isLoggedIn) {
        this.performLoggedInActions()
      } else {
        this.performLoggedOutActions()
      }
    },

    created () {
      window.setTimeout(() => {
        this.$store.commit(vuexTypes.KEEP_SESSION)
      }, 1000)
      this.subscribeToUserLogout()
      attachEventHandler(commonEvents.showTfaRecovery, () => {
        this.$router.push({name: 'settings.security', params: {tfaRecovery: true}})
      })
    },

    methods: {
      ...mapActions({
        loadAccount: vuexTypes.GET_ACCOUNT_DETAILS,
        loadBalances: vuexTypes.GET_ACCOUNT_BALANCES
      }),
      performLoggedInActions () {
        dispatchAppEvent(commonEvents.enterAppEvent)
        this.loadUserData()
        // alert('performLoggedInActions')
        // inactivityMessage.onLoginChanged(true)
      },
      performLoggedOutActions () {
        // alert('performLoggedOutActions')
        // inactivityMessage.onLoginChanged(false)
        /**
         * Here can be some conversion tracking logic for site visitors
         */
      },
      loadUserData () {
        this.loadAccount()
        this.loadBalances()
      },
      subscribeToUserLogout () {
        this.$store.subscribe(mutation => {
          switch (mutation.type) {
            case vuexTypes.SET_LOGGED_OUT_STATE:
              this.$router.push(vueRoutes.login)
              break
          }
        })
      },
      hideSidebar (status) {
        this.menuVisible = status
      },
      closePopup (status) {
        this.showPopup = status
      },
      openPopup () {
        this.showPopup = true
      }
    }
  }
</script>

<style lang="scss">
  @import '~scss/mixins';
  @import '~scss/variables';

  .md-app {
    height: 100vh;
  }

  .md-drawer {
    width: 340px;
    max-width: calc(100vw - 75px);
    @include border(1px, 0);

    @include respond-to(small) {
      height: 100%;
      overflow: auto;
    }
  }

  .mobile__menu-icon {
    display: none;

    @include respond-to(medium-tablet) {
      display: initial;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/root/App.vue